<template>
  <!-- Mobile -->
  <v-dialog
    v-if="$vuetify.breakpoint.xsOnly"
    v-model="mobileSearchDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>search</v-icon>
      </v-btn>
    </template>

    <v-card tile>
      <v-card-title class="py-2">
        <v-toolbar-title>Search for funds or securities</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          class="ma-0"
          @click="mobileSearchDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="filter"
          :items="filterItems"
          return-object
          menu-props="offset-y"
        />
        <v-autocomplete
          :search-input.sync="searchInput"
          :items="searchResults"
          :loading="loading"
          :hide-no-data="!searchInput || searchInput.length < 3 || loading"
          no-data-text="No such fund found"
          return-object
          item-text="label"
          item-value="id"
          cache-items
          placeholder="Search for a fund"
          prepend-inner-icon="search"
          append-icon=""
          menu-props="offsetY"
        >
          <template v-slot:item="data">
            <template>
              <v-list-item :href="genUrl(data.item)">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.labelTop }}</v-list-item-title>
                  <v-list-item-subtitle>{{ data.item.labelBottom }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Tablet & Desktop -->
  <div
    v-else
    class="app-toolbar__search-container"
  >
    <div class="app-toolbar__select mr-1">
      <v-select
        v-model="filter"
        :items="filterItems"
        return-object
        light
        solo
        dense
        text
        menu-props="offset-y"
        hide-details
      />
    </div>
    <div class="app-toolbar__autocomplete">
      <v-autocomplete
        :search-input.sync="searchInput"
        :items="searchResults"
        :loading="loading"
        :hide-no-data="!searchInput || searchInput.length < 3 || loading"
        no-data-text="No such fund found"
        return-object
        item-text="label"
        item-value="id"
        cache-items
        placeholder="Search for a fund"
        prepend-inner-icon="search"
        append-icon=""
        light
        solo
        dense
        text
        menu-props="offsetY"
        hide-details
      >
        <template v-slot:item="data">
          <template>
            <v-list-item :href="genUrl(data.item)">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.labelTop }}</v-list-item-title>
                <v-list-item-subtitle>{{ data.item.labelBottom }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
// Modules
import { apiRoot } from '@/store/api'

export default {
  data () {
    return {
      mobileSearchDialog: false,
      loading: false,
      searchInput: null,
      searchResults: [],
      filter: { text: 'Active', value: 6 },
      filterItems: [
        { text: 'All', value: 0 },
        { text: '13F Filers Only', value: 1 },
        { text: 'SEC Filer', value: 2 },
        { text: 'Stocks Only', value: 3 },
        { text: 'Mgmt Inv. Cos Only', value: 4 },
        { text: 'ETFs Only', value: 5 },
        { text: 'Active', value: 6 }
      ]
    }
  },

  watch: {
    filter (newFilter) {
      // 1 year from now
      const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))

      this.$cookie.set('search_filter', newFilter.value, { expires: expiryDate })
    },

    searchInput (val) {
      val && val.length > 2 && this.querySearch(val)
      this.searchInput = null
    }
  },

  created () {
    const cookie = this.$cookie.get('search_filter')

    if (!cookie) {
      // 1 year from now
      const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))

      // If we haven't created a search_filter cookie yet,
      // set filterItems[6] ('Active') as the default filter
      this.$cookie.set('search_filter', this.filterItems[6].value, { expires: expiryDate })
    } else {
      this.filter = this.filterItems[cookie]
    }
  },

  methods: {
    querySearch (val) {
      const query = `search/filer_stock_autocomplete2?filer_restrictions=${this.filter.value}&term=${encodeURIComponent(val)}`

      this.loading = true

      apiRoot.get(query)
        .then(res => {
          this.searchResults = res.data.map(obj => {
            obj.labelTop = obj.label.split('<br/>')[0]
            obj.labelBottom = obj.label.split('<br/>')[1]
            return obj
          })
        })
        .then(() => (this.loading = false))
    },

    genUrl (item) {
      const rectype = item.rectype === 'filer' ? 'filer' : 'stock'

      return `/${rectype}/${item.permalink}`
    }
  }
}
</script>

<style lang="scss">
#app-toolbar {
  .app-toolbar__search-container {
    display: flex;

    .app-toolbar__select{
      width: 150px;
    }
    .app-toolbar__autocomplete {
      width: 300px;
    }
  }
}
</style>
